import React from "react";

/**
 * MaintenancePage
 *
 * Full-screen overlay rendered when the backend signals maintenance mode.
 * The `html` prop contains the raw HTML string returned by the backend in
 * the `message` field of the 503 maintenance response body:
 *   { "status": "maintenance", "message": "<html string>" }
 *
 * The div is positioned fixed so it covers the entire viewport regardless
 * of the current scroll position or any other rendered content beneath it.
 * zIndex 99999 ensures it sits above the SSO loading overlay (zIndex 9999)
 * and all other portal UI.
 */
const MaintenancePage = ({ html }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 99999,
        overflow: "auto",
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default MaintenancePage;